module.exports = __webpack_public_path__ + "img/ricelog_pinicon_053.440dfc64.png";